import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@root/firebase';

/**
 * Logs a click-through event for a marketplace item
 *
 * @param {string} marketplaceId - The marketplace/ad/product document ID
 * @param {string} userId - The UID of the user who clicked (if available)
 * @param {object} [meta] - Optional metadata (e.g. referrer, source, type)
 */
export async function logMarketplaceClick(marketplaceId, userId, meta = {}) {
  if (!marketplaceId) return;

  try {
    const clicksCol = collection(db, `marketplace/${marketplaceId}/referrals`);
    await addDoc(clicksCol, {
      userId: userId || null,
      createdAt: serverTimestamp(),
      ...meta,
    });
    // You can optionally console.log for debugging
    console.log(`[Analytics] Referral logged for ${marketplaceId}`, meta);
  } catch (error) {
    console.error('Failed to log referral click:', error);
  }
}
